<div class="dialogue-content">
    <div class="mat-dialogue-header"></div>
    <mat-dialog-content>
        <div class="text-center">
            <form novalidate>
                <img src="../../../assets/images/delete-icon.svg" class="mb-4 m-auto d-table" />

                <h5 class="text-primary">Delete NFC URLs</h5>
                <p>Choose which of the selected NFC URLs you want to delete.</p>

                <mat-radio-group [(ngModel)]="selectedOption" name="deleteOption" class="delete-type-options">
                    <mat-radio-button *ngFor="let option of options" [value]="option" [disabled]="option.count === 0">
                        {{ option.label }} ({{ option.count }})
                    </mat-radio-button>
                </mat-radio-group>

                <p *ngIf="includesAllocated" class="text-danger small mt-3 mb-0">
                    Allocated URLs will be removed from the users.
                </p>

                <div class="d-flex align-items-center mt-4 flex-wrap justify-content-center gap-3">
                    <button matButton="filled" type="button" class="dialog-btn-secondary" mat-dialog-close
                        (click)="close()">No, Keep it!</button>
                    <button mat-flat-button type="button" class="dialog-btn-danger" (click)="confirmDelete()">
                        Yes, Delete!
                    </button>
                </div>
            </form>
        </div>
    </mat-dialog-content>
</div>
